import { render, staticRenderFns } from "./nullView.vue?vue&type=template&id=82858c12&scoped=true&"
import script from "./nullView.vue?vue&type=script&lang=js&"
export * from "./nullView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82858c12",
  null
  
)

export default component.exports